export var FlagDataType;
(function (FlagDataType) {
    FlagDataType[FlagDataType["Int32"] = 1] = "Int32";
    FlagDataType[FlagDataType["Float"] = 2] = "Float";
    FlagDataType[FlagDataType["Bool"] = 4] = "Bool";
    FlagDataType[FlagDataType["String"] = 8] = "String";
})(FlagDataType || (FlagDataType = {}));
